import React from 'react';

const skeletonStyle = {
  backgroundColor: '#e0e0e0',
  borderRadius: '8px',
  marginBottom: '10px',
  animation: 'pulse 1.5s infinite ease-in-out',
};


// .card-skeleton {
//     width: 100%;
//     max-width: 300px;
//     padding: 16px;
//     border-radius: 10px;
//     background-color: #fff;
//     box-shadow: 0 2px 8px rgba(0,0,0,0.1);
//     display: flex;
//     flex-direction: column;
//     gap: 12px;
//   }
  


const styles = {
    card: {
      width: '240px',
      padding: '8px',
      borderRadius: '10px',
      backgroundColor: '#fff',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    },
    image: {
      width: '100%',
      height: '150px',
    },
    title: {
      width: '60%',
      height: '20px',
    },
    text: {
      width: '80%',
      height: '14px',
    },
  };


// Add this to your global CSS or inside a <style> tag
// You can also use styled-components or CSS modules
const styleTag = document.createElement('style');
styleTag.innerHTML = `
@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.4; }
  100% { opacity: 1; }
}
`;
document.head.appendChild(styleTag);

  
const CardSkeleton = () => {
  return (
    <div style={styles.card}>
      <div style={{ ...styles.image, ...skeletonStyle }} />
      <div style={{ ...styles.title, ...skeletonStyle }} />
      <div style={{ ...styles.text, ...skeletonStyle }} />
    </div>
  );
};

export default CardSkeleton;
